import type { CSSProperties, FC } from "react";
import React from "react";

type ArenkoLogoProps = {
  color?: string;
  identColor?: string;
  style?: CSSProperties;
};

/**
 * Arenko brand logo.
 *
 * Inherits the parent text color. Both logo and ident colour can be explicitly set.
 */
const ArenkoLogo: FC<ArenkoLogoProps> = ({
  color = "currentColor",
  identColor = "currentColor",
  style,
}) => {
  const logoColor = color ? { fill: color } : undefined;
  const identStyle = identColor ? { fill: identColor } : undefined;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 160 34"
      height="30"
      style={style}
    >
      <title>Arenko</title>
      <g style={logoColor} fillRule="nonzero">
        <g className="ident" style={identStyle}>
          <path d="M18.979 0a2.67 2.67 0 0 1 2.68 2.68v27.873a2.67 2.67 0 0 1-2.68 2.681 2.67 2.67 0 0 1-2.681-2.68V2.68c0-1.447 1.234-2.681 2.68-2.681M2.68 11.532a2.67 2.67 0 0 1 2.682 2.68v4.937a2.67 2.67 0 0 1-2.681 2.68A2.67 2.67 0 0 1 0 19.15v-4.936a2.67 2.67 0 0 1 2.68-2.681M10.851 7.532a2.67 2.67 0 0 1 2.68 2.68v12.852a2.67 2.67 0 0 1-2.68 2.68 2.67 2.67 0 0 1-2.68-2.68V10.213c-.043-1.49 1.19-2.681 2.68-2.681M35.32 11.532a2.67 2.67 0 0 1 2.68 2.68v4.937a2.67 2.67 0 0 1-2.68 2.68 2.67 2.67 0 0 1-2.682-2.68v-4.936a2.67 2.67 0 0 1 2.681-2.681M27.149 7.532a2.67 2.67 0 0 1 2.68 2.68v12.852a2.67 2.67 0 0 1-2.68 2.68 2.67 2.67 0 0 1-2.68-2.68V10.213a2.67 2.67 0 0 1 2.68-2.681" />
        </g>
        <g className="name">
          <path d="M63.447 7.702a.808.808 0 0 0-.809.809V9.957c-.808-.893-1.872-1.617-3.064-2.085-.595-.212-1.191-.383-1.83-.425-.255-.043-.51-.043-.808-.043-5.276 0-9.191 4.043-9.191 9.405 0 5.361 3.872 9.446 9.191 9.446A8.29 8.29 0 0 0 58 26.17c.255-.042.51-.085.766-.17 1.49-.383 2.808-1.277 3.872-2.383v2.34h5.532V8.511a.808.808 0 0 0-.808-.809h-3.915Zm-5.532 14.383c-2.553 0-4.638-2.255-4.638-5.276 0-2.894 2.085-5.277 4.638-5.277 2.766 0 4.68 2.34 4.68 5.277 0 3.872-2.808 5.276-4.68 5.276M70.723 7.66h3.873c.468 0 .808.383.808.808v1.49c1.192-1.66 3.447-2.341 5.405-2.341 1.234 0 2.85.553 3.489.979l-2.894 4.085c-.17.34-.595.51-.978.383a3.95 3.95 0 0 0-1.022-.128c-2.042 0-4 1.702-4 3.873v9.106h-5.532V8.468c.043-.425.426-.808.851-.808M92.809 7.362c6.553 0 10.85 4.936 9.957 10.723h-14.51c.297 1.915 1.787 3.702 4.553 3.702 1.744 0 3.148-.723 3.787-1.744l5.66.085c-1.362 3.404-4.682 6.17-9.447 6.17-5.958 0-10.256-4.17-10.256-9.447 0-5.234 4.681-9.49 10.256-9.49m4.382 7.533c-.51-2.213-2.127-3.447-4.382-3.447-2.383 0-3.873 1.574-4.34 3.447h8.722ZM110.043 8.468v.936a7.188 7.188 0 0 1 5.106-2.085c5.106 0 7.787 3.83 7.787 8.17v10.426h-5.574V15.149c0-1.958-1.32-3.362-3.192-3.362-3.106 0-4.127 2.809-4.127 3.702v10.426h-5.532V8.468c0-.468.383-.808.808-.808h3.872c.511 0 .852.383.852.808M130.128 1.617v12.085l5.66-5.787a.84.84 0 0 1 .595-.255h5.021c.724 0 1.064.85.596 1.361l-6.213 6.596 7.532 10.298h-6.68l-4.724-6.17-1.787 1.872v4.298h-5.532V3.787a.84.84 0 0 1 .51-.766L128.98.98c.468-.256 1.064 0 1.106.51.043.085.043.128.043.128" />
          <path d="M159.83 16.809a9.448 9.448 0 0 0-8.979-9.447h-1.021c-4.979.255-8.979 4.383-8.979 9.447 0 4.34 2.936 8 6.936 9.106.809.213 1.66.298 2.51.298.852 0 1.703-.085 2.469-.298 4.128-1.021 7.064-4.724 7.064-9.106m-9.447 4.936c-2.638 0-3.957-2.213-3.957-4.936 0-2.724 1.319-4.937 3.957-4.937 2.468 0 4 2.085 4 4.937 0 2.723-1.32 4.936-4 4.936" />
        </g>
      </g>
    </svg>
  );
};

export default ArenkoLogo;
